<!-- src/components/index.vue -->

<template>
  <div v-if="usageType === 'profilePage'" class="image-container whiteboxshadow col-lg-3 col-md-4 col-6 mb-2" id="profilePageImages">
    <a :href="`/post/a/${image.id}`" class="black-box-shadow notextdeco">
      <img :src="image.image_url" :alt="image.description" class="fullimage align-self-center mb-4 mb-sm-0 rounded">
      <div class="image-overlay rounded">
        <h4 class="textmain mainHeading px-4 mobilePostFormat">{{ image.name }}</h4>
      </div>
    </a>
  </div>
  <div v-if="usageType === 'galleryPage'" class="image-container whiteboxshadow col-lg-3 col-md-4 col-6 p-1" id="profilePageImages">
    <a :href="`/post/a/${image.id}`" class="black-box-shadow notextdeco">
      <img :src="image.image_url" :alt="image.description" class="fullimage align-self-center mb-4 mb-sm-0 rounded">
      <div class="image-overlay rounded">
        <h4 class="textmain mainHeading px-4 mobilePostFormat">{{ image.name }}</h4>
      </div>
    </a>
  </div>
  <div v-if="usageType === 'featurePage'" class="image-container col-lg-4 col-md-4 col-6 mb-2 px-1">
    <a :href="`/post/a/${image.id}`" class="black-box-shadow notextdeco">
      <img :src="image.image_url" :alt="image.description" class="fullimage align-self-center mb-4 mb-sm-0 rounded ">
      <div class="image-overlay rounded">
        <h3 class="textmain mainHeading">{{ image.name }}</h3>
      </div>
    </a>
  </div>
</template>
<style scoped>

.image-container {
  position: relative;
  overflow: hidden;
}
.image-container a {
  display: block;
  position: relative;
  outline: none;
}
.image-container a:focus,
.image-container a:active,
.image-container a:hover,
.image-container a:-moz-focusring {
  outline: none;
}
.image-container img:-moz-focusring {
  outline: none;
}
.fullimage {
  width: 100%;
  aspect-ratio: 1 / 1; /* Makes height equal to width (square) */
  object-fit: cover; /* Crops image to maintain aspect ratio */
  display: block; /* Removes bottom space/margin of inline elements */
  margin-bottom: 0 !important; /* Prevent Bootstrap mb-4 from pushing overlay down */
}
.image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s ease;
  padding: 0.5rem;
}
.image-container:hover .image-overlay {
  opacity: 1;
}
</style>
<script>
import 'bootstrap/dist/css/bootstrap.min.css';
export default {
  name: 'imageComponent',
  props: {
    image: Object,
    usageType: String
  }
};
</script>
